export const setPortifolio = ({ portifolioID, section }) => state => {
  const portifolio = state.portifolios.find(
    portifolio => portifolio.id === portifolioID,
  ) || {
    id: undefined,
    name: undefined,
  };

  return {
    ...state,
    [section]: {
      ...state[section],
      portifolio,
    },
  };
};
